export const LAYOUT_DISPLAY = {
  "phone-pad": {
    "{space}": "space",
    "{bksp}": "⌫",
    "{enter}": "↵",
  },
  default: {
    "{shift}": "shift",
    "{bksp}": "⌫",
    "{alt}": "123",
    "{space}": "space",
    "{enter}": "↵",
  },
  "default-shift": {
    "{shift}": "shift",
    "{bksp}": "⌫",
    "{alt}": "123",
    "{space}": "space",
    "{enter}": "↵",
  },
  "default-alt": {
    "{shift}": "shift",
    "{bksp}": "⌫",
    "{alt}": "abc",
    "{space}": "space",
    "{enter}": "↵",
  },
  email: {
    "{shift}": "shift",
    "{bksp}": "⌫",
    "{alt}": "123",
    "{space}": "space",
    "{enter}": "↵",
  },
  "email-shift": {
    "{shift}": "shift",
    "{bksp}": "⌫",
    "{alt}": "123",
    "{space}": "space",
    "{enter}": "↵",
  },
  "email-alt": {
    "{shift}": "shift",
    "{bksp}": "⌫",
    "{alt}": "abc",
    "{space}": "space",
    "{enter}": "↵",
  },
  pin: {},
} as const;

export type LayoutType = keyof typeof LAYOUT_DISPLAY;

export const LAYOUT = {
  default: [
    // "+ 1 2 3 4 5 6 7 8 9 0",
    "q w e r t y u i o p",
    "a s d f g h j k l",
    "{shift} z x c v b n m {bksp}",
    "{alt} , {space} . {enter}",
  ],
  "default-alt": [
    "1 2 3 4 5 6 7 8 9 0",
    "@ # $ _ & - + ( ) /",
    `* " ' : ; ! ? {bksp}`,
    "{alt} , {space} . {enter}",
  ],
  "default-shift": [
    // "~ ! @ # $ % ^ &amp; * ( ) _ ` {bksp}",
    "Q W E R T Y U I O P",
    "A S D F G H J K L",
    "{shift} Z X C V B N M {bksp}",
    "{alt} , {space} . {enter}",
  ],
  "phone-pad": [
    "1 2 3 {//}", //
    "4 5 6 {//}", //
    "7 8 9 {bksp}", //
    "+ 0 # {enter}", //
  ],
  email: [
    "q w e r t y u i o p",
    "a s d f g h j k l",
    "{shift} z x c v b n m {bksp}",
    "{alt} {space} @ . {enter}",
  ],
  "email-alt": [
    "1 2 3 4 5 6 7 8 9 0",
    "@ # $ _ & - + ( ) /",
    `* " ' : ; ! ? {bksp}`,
    "{alt} {space} . {enter}",
  ],
  "email-shift": [
    "Q W E R T Y U I O P",
    "A S D F G H J K L",
    "{shift} Z X C V B N M {bksp}",
    "{alt} {space} @ . {enter}",
  ],
  pin: [
    "1 2 3",
    "4 5 6",
    "7 8 9",
    "{//} 0 {//}",
    "{bksp}", //
  ],
};
